import { render, staticRenderFns } from "./addrechargeChannelGame.vue?vue&type=template&id=b6e99ed8&scoped=true&"
import script from "./addrechargeChannelGame.vue?vue&type=script&lang=js&"
export * from "./addrechargeChannelGame.vue?vue&type=script&lang=js&"
import style0 from "./addrechargeChannelGame.vue?vue&type=style&index=0&id=b6e99ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e99ed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6e99ed8')) {
      api.createRecord('b6e99ed8', component.options)
    } else {
      api.reload('b6e99ed8', component.options)
    }
    module.hot.accept("./addrechargeChannelGame.vue?vue&type=template&id=b6e99ed8&scoped=true&", function () {
      api.rerender('b6e99ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/components/addrechargeChannelGame.vue"
export default component.exports